import { defineAsyncComponent } from "vue";
import {
  createRouter,
  createWebHistory,
  RouteLocationNormalized,
} from "vue-router";
import LoadingSpinner from "@two-ui/components/LoadingSpinner.vue";
import AuthLogin from "@two-ui/views/AuthLogin.vue";
import {
  PAYOUT_TEMPLATE_HELP_URL,
  REDEMPTION_TEMPLATE_HELP_URL,
} from "./constants";

export function initCustomizationRoutes() {
  return [
    {
      path: "/",
      redirect: "/customization",
    },
    {
      path: "/login",
      component: AuthLogin,
      name: "auth-login",
      meta: { preAuth: true },
    },
    {
      path: "/customization",
      name: "customization",
      component: async () =>
        defineAsyncComponent({
          loader: () => import("./views/BasePage.vue"),
          loadingComponent: LoadingSpinner,
        }),
      children: subRoutesCustomization,
      meta: { requiresCustomerId: true },
    },
  ];
}

export const subRoutesCustomization = [
  {
    path: "user-redemption",
    name: "user-redemption-home",
    component: async () =>
      defineAsyncComponent({
        loader: () => import("./views/RedemptionHome.vue"),
        loadingComponent: LoadingSpinner,
      }),
    meta: {
      breadCrumbTitle: "User redemption",
    },
  },
  {
    path: "user-redemption/template/create",
    name: "user-redemption-create",
    component: async () =>
      defineAsyncComponent({
        loader: () => import("./views/RedemptionTemplateCreate.vue"),
        loadingComponent: LoadingSpinner,
      }),
    meta: {
      hideSidebar: true,
      useHeader: true,
      closeUrl: "user-redemption-home",
      helpUrl: REDEMPTION_TEMPLATE_HELP_URL,
    },
  },
  {
    path: "user-redemption/template/:id/edit",
    name: "user-redemption-edit",
    component: async () =>
      defineAsyncComponent({
        loader: () => import("./views/RedemptionTemplateCreate.vue"),
        loadingComponent: LoadingSpinner,
      }),
    meta: {
      hideSidebar: true,
      useHeader: true,
      closeUrl: "user-redemption-home",
      helpUrl: REDEMPTION_TEMPLATE_HELP_URL,
    },
  },
  {
    path: "user-redemption/template/:id",
    name: "user-redemption-template-details",
    component: async () =>
      defineAsyncComponent({
        loader: () => import("./views/RedemptionTemplateDetails.vue"),
        loadingComponent: LoadingSpinner,
      }),
    meta: {
      breadCrumbTitle: " ",
    },
  },
  {
    path: "payout-selection",
    name: "payout-selection-home",
    component: async () =>
      defineAsyncComponent({
        loader: () => import("./views/PayoutHome.vue"),
        loadingComponent: LoadingSpinner,
      }),
    meta: {
      breadCrumbTitle: "Merchant selection",
    },
  },
  {
    path: "payout-selection/template/create",
    name: "payout-selection-create",
    component: async () =>
      defineAsyncComponent({
        loader: () => import("./views/PayoutTemplateCreate.vue"),
        loadingComponent: LoadingSpinner,
      }),
    meta: {
      hideSidebar: true,
      useHeader: true,
      closeUrl: "payout-selection-home",
      helpUrl: PAYOUT_TEMPLATE_HELP_URL,
    },
  },
  {
    path: "payout-selection/template/:id/edit",
    name: "payout-selection-edit",
    component: async () =>
      defineAsyncComponent({
        loader: () => import("./views/PayoutTemplateCreate.vue"),
        loadingComponent: LoadingSpinner,
      }),
    meta: {
      hideSidebar: true,
      useHeader: true,
      closeUrl: "payout-selection-home",
      helpUrl: PAYOUT_TEMPLATE_HELP_URL,
    },
  },
  {
    path: "payout-selection/template/:id",
    name: "payout-selection-template-details",
    component: async () =>
      defineAsyncComponent({
        loader: () => import("./views/PayoutTemplateDetails.vue"),
        loadingComponent: LoadingSpinner,
      }),
    meta: {
      breadCrumbTitle: " ",
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (from.meta.scrollTopOnLeave || to.meta.scrollTopOnEnter)
      return {
        top: 0,
        left: 0,
      };
    else if (savedPosition) return savedPosition;
  },
  routes: initCustomizationRoutes(),
});

router.beforeEach(
  (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    // pass query params to route
    if (to.meta.keepParams) {
      const hasQueryStringsFrom = !!Object.keys(from.query).length;
      const hasQueryStringsTo = !!Object.keys(to.query).length;

      if (!hasQueryStringsTo && hasQueryStringsFrom) {
        return { name: to.name!, query: from.query };
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
);

export default router;
